import React, { useState, useEffect, useRef } from "react";
import styles from "../EditDiv/EditDiv.module.css";
import buttonStyles from "../YesNoButtonsCSS/YesNoButtons.module.css";
import BlueLogo from "../../assets/BlueLogo.png";
import { Box, Grid, TextField, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "../../redux/store";
import CommentBox from "../CommentBox/CommentBox";
import DropDownV2 from "../DropDownBox/DropdownV2";
import Dropdown from "../DropDownBox/Dropdown";
import { Form, FormikProvider } from "formik";
import { useFormik } from "formik";
import * as Yup from "yup";
import textfieldStyle from "../../GlobalStyles/styles";
import { getClientData } from "../../redux/slices/opportunitiesdata";

const OppForm = ({ onSubmit, onClose }) => {
  const dispatch = useDispatch();
  const { configuration, billPayer, client, newClient } = useSelector(
    (state) => state.opportunities
  );

  const [jobTypes, setJobTypes] = useState([]);
  const [oppSources, setOppSources] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);
  const backdropRef = useRef(null);
  const formRef = useRef(null);

  // Initialize state for each form field
  const [values, setValues] = useState({
    address: "",
    city: "",
    postcode: "",
    architectCompanyName: "",
    homeOwnerName: "",
    architectName: "",
    issueEmail: "",
    sourceOfOppName: "",
    jobTypeName: "",
    projectTypeName: "",
    comment: "",
  });

  useEffect(() => {
    if (configuration) {
      const formattedJobTypes = configuration.jobTypes.map((jobType) => ({
        value: jobType.id,
        label: jobType.name,
      }));
      setJobTypes(formattedJobTypes);

      const formattedOppSource = configuration.sourceOfOpportunities.map(
        (oppSource) => ({
          value: oppSource.id,
          label: oppSource.name,
        })
      );
      setOppSources(formattedOppSource);

    }
  }, [configuration]);

  const handleSearchChange = (newSearchTerm, client_type) => {
    // Determine which state to update based on client_type
    let targetState = 'billPayer'; // default

    if (client_type === "home_owner,company") {
      targetState = 'billPayer';
    } else if (client_type === "company,current_bill_payer") {
      targetState = 'client';
    }

    dispatch(getClientData(newSearchTerm, client_type, targetState));
  };

  const handleFormClick = (e) => {
    e.stopPropagation(); // Stops the click event from bubbling up to the parent div
  };

  const initialValues = {
    address: "",
    city: "",
    postcode: "",
    homeOwnerName: "",
    architectCompanyName: "",
    clientID: "",
    homeOwnerID: "",
    architectName: "",
    issueEmail: "",
    sourceOfOppID: "",
    sourceOfOppName: "",
    jobTypeID: "",
    jobTypeName: "",
    projectTypeName: "Blue",
    comment: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: OppSchema,
    onSubmit: async (values, { resetForm }) => {
      onSubmit(values);
      onClose();
      console.log(values);
    },
  });
  const { getFieldProps, touched, errors, handleSubmit } = formik;

  // Convert formik string values to dropdown object format
  const homeOwnerSelectedValue = formik.values.homeOwnerName && formik.values.homeOwnerID
    ? { value: formik.values.homeOwnerID, label: formik.values.homeOwnerName }
    : null;

  const architectSelectedValue = formik.values.architectCompanyName && formik.values.clientID
    ? { value: formik.values.clientID, label: formik.values.architectCompanyName }
    : null;
  // Ensure modal opens scrolled to the top and content is top-aligned
  useEffect(() => {
    if (backdropRef.current) backdropRef.current.scrollTop = 0;
    if (formRef.current) formRef.current.scrollTop = 0;
  }, []);

  return (
    <div className={styles.backGround} ref={backdropRef}>
      <div
        className={styles.form}
        ref={formRef}
        style={{
          width: "500px",
          maxHeight: "80vh",
          overflowY: "auto",
          justifyContent: "flex-start",
          alignItems: "stretch",
          paddingTop: 12,
          paddingBottom: 8,
        }}
        onClick={handleFormClick}
      >
        <div className={styles.momentTitle}>MOMENT</div>
        <div className={styles.sectionTitle}>{`Fee Proposal Form`}</div>

        <FormikProvider value={formik} handleSubmit={handleSubmit}>
          <Form autoComplete="off" noValidate style={{ width: "100%" }}>
            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Address line 1: </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  value={formik.values.address}
                  type="text"
                  onChange={(e) =>
                    formik.setFieldValue("address", e?.target?.value)
                  }
                  placeholder="Address line 1"
                  sx={textfieldStyle}
                  error={Boolean(touched.address && errors.address)}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>City: </p>
                {/* {"Address" + ":"} */}
                {/* {subLabel && (
                  <div className={styles.dataSubTitle}>{subLabel}</div>
                )} */}
                {/* </div> */}
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  value={formik.values.city}
                  type="text"
                  onChange={(e) =>
                    formik.setFieldValue("city", e?.target?.value)
                  }
                  placeholder="City"
                  sx={textfieldStyle}
                  error={Boolean(touched.city && errors.city)}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Post Code: </p>
                {/* {"Address" + ":"} */}
                {/* {subLabel && (
                  <div className={styles.dataSubTitle}>{subLabel}</div>
                )} */}
                {/* </div> */}
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  value={formik.values.postcode}
                  type="text"
                  onChange={(e) =>
                    formik.setFieldValue("postcode", e?.target?.value)
                  }
                  placeholder="Post Code"
                  sx={textfieldStyle}
                  error={Boolean(touched.postcode && errors.postcode)}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Who is paying our bill? </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1.5 }}>
                <DropDownV2
                  options={billPayer}
                  initialSelectedValue={homeOwnerSelectedValue}
                  placeholder={"Select Home Owner"}
                  onValueChange={(newValue) => {
                    formik.setFieldValue(
                      "homeOwnerName",
                      newValue.label
                    );
                    formik.setFieldValue("homeOwnerID", newValue.value);
                  }}
                  onSearchChange={handleSearchChange}
                  PopUp={true}
                  searchable={true}
                  addNew={true}
                  errorState={Boolean(
                    touched.homeOwnerName && errors.homeOwnerName
                  )}
                  clientType="home_owner,company"
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>
                  Who is the architecture practice?{" "}
                </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1.5 }}>
                <DropDownV2
                  options={client}
                  initialSelectedValue={architectSelectedValue}
                  placeholder={"Select Architect"}
                  onValueChange={(newValue) => {
                    formik.setFieldValue(
                      "architectCompanyName",
                      newValue.label
                    );
                    formik.setFieldValue("clientID", newValue.value);
                  }}
                  onSearchChange={handleSearchChange}
                  PopUp={true}
                  searchable={true}
                  addNew={true}
                  errorState={Boolean(
                    touched.architectCompanyName && errors.architectCompanyName
                  )}
                  clientType={"company,current_bill_payer"}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p
                  className={styles.dataTitleV2}
                  style={{ pb: 0, mb: 0 }}
                >
                  Who is the contact at the design practice?{" "}
                </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1.5 }}>
                <TextField
                  fullWidth
                  value={formik.values.architectName}
                  type="text"
                  onChange={(e) =>
                    formik.setFieldValue("architectName", e?.target?.value)
                  }
                  placeholder="Name Of Architect"
                  sx={textfieldStyle}
                  error={Boolean(touched.architectName && errors.architectName)}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%", mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Who is the Proposal Addressed to?{" "}
                </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  value={formik.values.issueEmail}
                  type="text"
                  onChange={(e) =>
                    formik.setFieldValue("issueEmail", e?.target?.value)
                  }
                  placeholder="Issue Email"
                  sx={textfieldStyle}
                  error={Boolean(touched.issueEmail && errors.issueEmail)}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Source Of Opportunity:{" "}
                </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1.5 }}>
                <DropDownV2
                  options={oppSources}
                  initialSelectedValue={
                    oppSources.find(
                      (o) =>
                        o.value === formik.values.sourceOfOppID ||
                        o.label === formik.values.sourceOfOppName
                    ) || {}
                  }
                  placeholder={"Select Source of Opportunity"}
                  onValueChange={(newValue) => {
                    formik.setFieldValue("sourceOfOppName", newValue.label);
                    formik.setFieldValue("sourceOfOppID", newValue.value);
                  }}
                  errorState={Boolean(
                    touched.sourceOfOppName && errors.sourceOfOppName
                  )}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Job Type:{" "}
                </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1.5 }}>
                <DropDownV2
                  options={jobTypes}
                  initialSelectedValue={
                    jobTypes.find(
                      (o) =>
                        o.value === formik.values.jobTypeID ||
                        o.label === formik.values.jobTypeName
                    ) || {}
                  }
                  placeholder={"Select Job Type"}
                  onValueChange={(newValue) => {
                    formik.setFieldValue("jobTypeName", newValue.label);
                    formik.setFieldValue("jobTypeID", newValue.value);
                  }}
                  errorState={Boolean(
                    touched.jobTypeName && errors.jobTypeName
                  )}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Project Type:{" "}
                </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1.5 }}>
                <DropDownV2
                  options={[
                    { value: "Blue", label: "Blue" },
                    { value: "Re-S", label: "Re-S" }
                  ]}
                  initialSelectedValue={
                    [
                      { value: "Blue", label: "Blue" },
                      { value: "Re-S", label: "Re-S" }
                    ].find(
                      (o) =>
                        o.value === formik.values.projectTypeName ||
                        o.label === formik.values.projectTypeName
                    ) || {}
                  }
                  placeholder={"Select Project Type"}
                  onValueChange={(newValue) => {
                    formik.setFieldValue("projectTypeName", newValue.label);
                  }}
                  errorState={Boolean(
                    touched.projectTypeName && errors.projectTypeName
                  )}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ width: "100%" }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2} style={{ pb: 0, mb: 0 }}>
                  Comments:{" "}
                </p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  multiline
                  value={formik.values.comment}
                  type="text"
                  onChange={(e) =>
                    formik.setFieldValue("comment", e?.target?.value)
                  }
                  rows={2}
                  placeholder="Comment"
                  sx={textfieldStyle}
                  //   textareaStyle={textfieldStyle}
                  inputProps={{ style: { margin: 0 } }}
                />
              </Grid>
            </Grid>
            <div className={styles.updateAndCancel}>
              <div
                className={styles.updateButton}
                type="submit"
                onClick={handleSubmit}
              >
                <div className={buttonStyles.YesButtonComponentStyling}>
                  SUBMIT
                </div>
              </div>
              <div className={styles.cancelButton} onClick={onClose}>
                <div className={buttonStyles.NoButtonComponentStyling}>
                  CANCEL
                </div>
              </div>
            </div>
          </Form>
        </FormikProvider>
        {/* <ul className={styles.List}>{formFieldsConfig.map(renderField)}</ul> */}

        <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" style={{ alignSelf: 'center' }} />
      </div>
    </div>
  );
};

const OppSchema = Yup.object().shape({
  address: Yup.string().required(),
  city: Yup.string().required(),
  postcode: Yup.string().required(),
  homeOwnerName: Yup.string().required(),
  architectCompanyName: Yup.string().required(),
  architectName: Yup.string().required(),
  issueEmail: Yup.string().required(),
  sourceOfOppName: Yup.string().required(),
  jobTypeName: Yup.string().required(),
  projectTypeName: Yup.string().required(),
});

export default OppForm;
